import { CaseProjection } from '../../CaseProjection';

export const getCaseSurfaceForSaleMaximum = (caseProjection: CaseProjection): number => {
  return caseProjection.projectedCuttedBuiltSurface.value;
};
